<template>
  <template v-if="product">
    <div v-if="productNote" class="product__note" v-html="productNote"></div>
  </template>
  <template v-else>
    <div class="product__note">
      <sib-skeleton-loading
        v-for="index in 2"
        :key="index"
      ></sib-skeleton-loading>
      <sib-skeleton-loading width="70%"></sib-skeleton-loading>
    </div>
  </template>
</template>

<script lang="ts" setup>
import { nextTick, watch } from 'vue'
import { computed } from '@vue/reactivity'
import {
  AB_TEST_CODE_SHOW_VIDEO_BEHIND_THE_ATC_BUTTON,
  AB_TEST_CODE_SHOW_VIDEO_ON_PRODUCT_IMAGES,
} from '@/utils'
import { useABTest } from '@/composables/useABTest'
import useProductStore from '@/store/product'

const { getABTestActivedVariantByCode } = useABTest()
const store = useProductStore()

const abtestVariantShowVideoOnProductImages = computed(() => {
  const abtestVariant = getABTestActivedVariantByCode(
    AB_TEST_CODE_SHOW_VIDEO_ON_PRODUCT_IMAGES
  )
  return abtestVariant
})
const productNote = computed(() => store.productDescription?.attention)
const product = computed(() => store.product)

watch(
  () => productNote.value,
  async (value) => {
    if (!value || !abtestVariantShowVideoOnProductImages.value) return
    await nextTick()
    if (
      abtestVariantShowVideoOnProductImages.value !==
      AB_TEST_CODE_SHOW_VIDEO_BEHIND_THE_ATC_BUTTON
    ) {
      const iframeProductVideo: HTMLElement | null = document.querySelector(
        '.product__note .iframe-product-video'
      )
      if (!iframeProductVideo) return
      iframeProductVideo.style.display = 'none'
    }
  }
)
</script>

<style lang="scss">
.product__note {
  margin-top: var(--space-medium);
}
</style>
